import React, { useEffect, useState } from 'react'
import { Layout, Card, Form, message, Input } from 'antd'
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { redirectLogin } from '../../helpers/auth/useSession';
import BlueButton from '../../components/shared/BlueButton';
import { verifyCompany } from '../../api/auth';

const { Header } = Layout;

export default function CompanyVerification() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            redirectLogin();
        }
    }, [token]);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const res = await verifyCompany({ ...values, token });
            if (res.Code === 1) {
                message.success("Verification successfull.");
                navigate("/");
            } else {
                message.error(res.Data.message || "Something went wrong, please try again later");
            }
        } catch (error) {
            console.log(error)
            message.error("Something went wrong, please try again later");
        }
        setLoading(false);
    }

    const onFinishFailed = (errorInfo) => {
        console.log("Failed:", errorInfo);
        message.error("Something went wrong, please try again later");
    };

    return (
        <div className='flex flex-col items-center justify-start bg-gray-200 h-full'>
            <Header className="flex items-center justify-between px-[16px] h-[48px] w-full bg-[#f19820]">
                <Link to="/">
                    <h3 className="text-white font-bold text-lg leading-8 flex flex-col justify-center cursor-pointer">
                        TrakHire
                    </h3>
                </Link>
            </Header >

            <Card title="Complete your Profile" className='mt-20 max-w-lg md:min-w-[400px] rounded-none'>
                <div className='py-4 px-8'>
                    <Form form={form} layout='vertical' onFinish={onFinish} onFinishFailed={onFinishFailed}>
                        <Form.Item name="firstName" label="First Name" rules={[{ required: true }]} >
                            <Input className='rounded-none' />
                        </Form.Item>
                        <Form.Item name="lastName" label="Last Name" rules={[{ required: true }]} >
                            <Input className='rounded-none' />
                        </Form.Item>
                        <Form.Item name="password" label="Password" rules={[{ required: true }]} >
                            <Input.Password className='rounded-none' />
                        </Form.Item>
                        <Form.Item name="confirm" label="Confirm Password" rules={[{ required: true }]} >
                            <Input.Password className='rounded-none' />
                        </Form.Item>
                        <Form.Item>
                            <BlueButton type="primary" className="rounded-none" htmlType="submit" disabled={loading}>Save</BlueButton>
                        </Form.Item>
                    </Form>
                </div>
            </Card>

        </div>
    )
}
